export const employees = '/user';
export const updateEmployeeStatus = '/user/updateStatus/';
export const addEmployee = '/user';
export const updateEmployee = '/user/';
export const getEmployeeDetails = '/user/getUserById/';
export const getEmployeeActivity = '/user/userActivityById/';
export const searchEmployeesInterns = '/user/searchEmployeeAndInterns';
